import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { UsuarioService } from "app/base-module/base-service/usuario.service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";
import { Escritorio } from "app/empresas/models/escritorio.model";
import { Usuario } from "app/usuarios/models/user.model";
import { map, Observable } from "rxjs";

export interface DialogData {
    id: number;
}

interface IAtivo {
    id: number;
    nome: string;
    sigla: string;
}

@Component({
    selector: "app-filtra-operacao-estruturada",
    templateUrl: "./filtra-operacao-estruturada.component.html",
    styleUrls: ["./filtra-operacao-estruturada.component.scss"],
    providers: [ClienteService, AtivoService, EscritorioService],
})
export class FiltraOperacaoEstruturadaComponent extends BaseComponent {
    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    cliente = new FormControl("");
    ativo = new FormControl("");
    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);
    assessor_id = new FormControl("");
    escritorio_id = new FormControl("");

    paramsStatus: any = {
        finalizada: "",
    };

    usuario: any;
    habilitaEscritorios: boolean = false;
    loadingSpinner!: boolean;
    loadingSpinnerStatus!: boolean;
    loadingSpinnerAssessor!: boolean;
    loadingSpinnerAtivos!: boolean;
    loadingSpinnerEscritorio!: boolean;
    filteredOptions!: Observable<ClienteModel[]>;
    listAssessor: Usuario[] = [];
    listAtivos: IAtivo[] = [];
    listEscritorios: Escritorio[] = [];
    filteredOptionsAtivo!: Observable<IAtivo[]>;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltraOperacaoEstruturadaComponent, { static: false })
    table!: FiltraOperacaoEstruturadaComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltraOperacaoEstruturadaComponent>,
        private _clienteService: ClienteService,
        private _utilitesService: UtilitesService,
        private _ativoService: AtivoService,
        public escritorioService: EscritorioService,
        private usuarioService: UsuarioService,
        private _authService: AuthService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);
        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}");

        if (this.usuario.escritorios.length > 1) {
            this.habilitaEscritorios = true;
        }

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
            }
        });

        this.ativo.valueChanges.subscribe((query) => {
            if (typeof query === "string") {
                this.loadingSpinnerAtivos = true;
                this.params.search = query;
                this.params.tipo = "NORMAL";
                this.filteredOptionsAtivo = this._ativoService.search(
                    this.params
                );
            }
        });

        this.getAllEscritorios();
        this.getAssessores();
    }

    displayFn(cliente: ClienteModel): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar(): void {
        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(
                this.data_operacao_inicio.value ?? new Date()
            );
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(
                this.data_operacao_fim.value ?? new Date()
            );
        }

        this.dialogRef.close({
            cliente: this.cliente.value,
            data_operacao_inicio: inic,
            data_operacao_fim: fim,
            ativo: this.ativo.value,
            assessor_id: this.assessor_id.value,
            escritorio_id: this.escritorio_id.value,
        });
    }

    displayFnAtivo(ativo: IAtivo): string {
        if (ativo) {
            return ativo.sigla;
        }
        return "";
    }

    selectEscritorio(event: any) {
        this.escritorio_id.setValue(event.value);
        this.getAssessores(event.value);
    }

    getAtivo(ativo: any): void {
        this.loadingSpinnerAtivos = false;
    }

    getAtivos(): void {
        this.loadingSpinnerAtivos = true;
        this._ativoService.getAll({ no_paginate: true }).subscribe(
            (resquest) => {
                this.listAtivos = resquest.data;
            },
            (error) => {
                this.loadingSpinnerAtivos = false;
            },
            () => {
                this.loadingSpinnerAtivos = false;
            }
        );
    }

    getAllEscritorios() {
        this.loadingSpinnerEscritorio = true;
        this.escritorioService.getAllList({ no_paginate: true }).subscribe(
            (list) => {
                this.listEscritorios = list.data ?? [];
            },
            (error) => {
                this.loadingSpinnerEscritorio = false;
            },
            () => {
                this.loadingSpinnerEscritorio = false;
            }
        );
    }

    getAssessores(escritorio_id = "") {
        this.loadingSpinnerAssessor = true;
        this.usuarioService
            .getLista({ escritorio_id: escritorio_id })
            .subscribe(
                (resquest) => {
                    this.listAssessor = resquest.data ?? [];
                },
                (error) => {
                    this.loadingSpinnerAssessor = false;
                },
                () => {
                    this.loadingSpinnerAssessor = false;
                }
            );
    }
}
